import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { AssignPropertiesFieldNames } from '../../modules/enterprisePolicies/_shared/types';

type PropertySelectFieldProps = Partial<Omit<SelectFieldProps, 'options' | 'name' | 'label'>> & {
    filteredPropertyIds?: string[];
    propertyIds?: string[];
};

export const PropertySelectField = ({ filteredPropertyIds, ...props }: PropertySelectFieldProps) => {
    const propertyOptionsQuery = useRepositorySuspenseQuery(
        'portfolioEnterpriseRelationships',
        'getAll',
        {
            pagination: { pageSize: 0, pageIndex: 0 },
        },
        {
            select: ({ data }) =>
                pipe(
                    data,
                    array.filterMap(({ id, name }) =>
                        filteredPropertyIds?.includes(id)
                            ? option.none
                            : option.some(
                                  createOption({
                                      label: name,
                                      value: id,
                                      disabled: props.propertyIds?.includes(id),
                                      inactive: true,
                                  })
                              )
                    )
                ),
        }
    );

    return (
        <SelectField
            overlayMaxHeight={300} // fixes dropdown list strictly to below the field
            name={AssignPropertiesFieldNames.Properties}
            label={lt('Properties')}
            options={propertyOptionsQuery.data}
            {...props}
        />
    );
};
